// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WwVx","newExpiryDate":"styles_newExpiryDate__1pHS7","footer":"styles_footer__2CrGk"};